import { SweetAlertService } from './../../shared/services/sweet-alert.service';
import { AuthenticationService } from './../authentication/authentication.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
// eslint-disable-next-line max-len
import { ExpirePasswordReminderModalComponent } from '../../shared/components/expire-password-reminder-modal/expire-password-reminder-modal.component';
import { environment } from '../../../environments/environment';
import { LoginResponse, User } from 'src/app/shared/models/user.models';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @ViewChild('expireModal') expireModal: ExpirePasswordReminderModalComponent;

  loginForm: FormGroup;
  passwordLoading = false;
  samlLoading = false;
  returnUrl: string;
  error = '';
  enableSamlLogin = environment.enableSamlLogin;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private swal: SweetAlertService
  ) {
    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit(): void {
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    if (this.route.snapshot.queryParams.saml?.toLowerCase() === 'true') {
      this.onSamlCallBack();
    }

    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  // convenience getter for easy access to form fields
  get f(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }

  samlLogin(): void {
    window.location.href = `${environment.baseUrl}/backend/api/saml/login/?return_to=${this.returnUrl}`;
  }

  onSamlCallBack(): void {
    this.samlLoading = true;

    const success =
      this.route.snapshot.queryParams.success?.toLowerCase() === 'true';
    if (!success) {
      const message = this.route.snapshot.queryParams.message;
      this.samlLoading = false;
      this.swal.toast({
        type: 'error',
        error: message || 'SAML login failed!',
      });
      return;
    }

    const user = JSON.parse(
      atob(this.route.snapshot.queryParams.data)
    ) as LoginResponse;
    this.authenticationService.saveCurrentUser(user, true);
    this.onLoginSuccess(user.user);
  }

  onSubmit(): void {
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.passwordLoading = true;
    this.authenticationService
      .login(this.f.username.value, this.f.password.value)
      .pipe(first())
      .subscribe(
        (res) => {
          this.onLoginSuccess(res.user);
        },
        (error) => {
          this.error = error;
          this.passwordLoading = false;
          this.swal.toast({ type: 'error', error: error.error });
        }
      );
  }

  onLoginSuccess(user: User): void {
    const expiredPassword = user.expired_password;
    const defaultPasswordChanged = user.default_password_changed;
    const role = user.role;

    if (!defaultPasswordChanged) {
      this.router.navigate(['/change-password']);
      return;
    }
    if (expiredPassword && role !== 'associate') {
      this.router.navigate(['/change-password']);
      return;
    }

    this.router.navigateByUrl(this.returnUrl);

    if (user.show_expire_password_reminder) {
      this.expireModal.open();
    }
  }
}
